import { gql, useQuery } from '@apollo/client';

export const GET_DOCUMENT_TEMPLATE_BY_ID = gql`
  query ($documentTemplateId: String!) {
    getDocumentTemplateById(documentTemplateId: $documentTemplateId) {
      _id
      title
      fileId
      documentLabelId
      file {
        _id
        key
        filename
        location
      }
    }
  }
`;

export const useGetDocumentTemplateById = (documentTemplateId: string) => {
  const { data, loading } = useQuery(GET_DOCUMENT_TEMPLATE_BY_ID, {
    variables: { documentTemplateId },
    skip: !documentTemplateId,
  });
  const { getDocumentTemplateById = {} } = data || {};

  return { documentTemplate: getDocumentTemplateById, loading };
};
